export function formatTime2MS(time: number): string {
  const minutes = Math.floor(time / 60000);
  const seconds = Math.floor((time % 60000) / 1000);
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}


/**
 * 转换录制时长，当录制总时长超过1小时，显示时分秒，否则只显示分秒
 * @param recordTime 
 */
export function formatRecordDuration(recordTime: number, durationTime: number): string {
  const hours = Math.floor(durationTime / 3600);
  if (hours > 0) {
    return formatSeconds2HMS(recordTime);
  }
  return formatSeconds2MS(recordTime);
}


/**
 * 转换录制时间，当录制总时长超过1小时，显示时分秒，否则只显示分秒
 * @param recordTime 
 */
export function formatRecordTime(recordTime: number): string {
  const hours = Math.floor(recordTime / 3600);
  if (hours > 0) {
    return formatSeconds2HMS(recordTime);
  }
  return formatSeconds2MS(recordTime);
}


/**
 * 秒数转换为分钟秒数字符串（00:00）
 * @param time
 * @returns
 */
export function formatSeconds2MS(time: number): string {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
}

/**
 * 秒数转换为分钟秒数字符串（00分00秒）
 * @param time
 * @returns
 */
export function formatSeconds2HMSInChinese(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  if (hours > 0) {
    return `${hours.toString()}时${minutes.toString()}分${secs.toString()}秒`;
  }
  if (minutes > 0) {
    return `${minutes.toString()}分${secs.toString()}秒`;
  }
  return `${secs.toString()}秒`;
}


/**
 * 秒数转换为时分钟秒数字符串（00:00:00）
 * @param time
 * @returns
 */
export function formatSeconds2HMS(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  // 使用 padStart 方法确保每个部分都是两位数
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(secs).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function formatBytes(size: number): string {
  let sizeStr = "";
  if (size < 0.1 * 1024) {                            //小于0.1KB，则转化成B
    sizeStr = size.toFixed(2) + " B"
  } else if (size < 0.1 * 1024 * 1024) {            //小于0.1MB，则转化成KB
    sizeStr = (size / 1024).toFixed(2) + " KB"
  } else if (size < 0.1 * 1024 * 1024 * 1024) {        //小于0.1GB，则转化成MB
    sizeStr = (size / (1024 * 1024)).toFixed(2) + " MB"
  } else {                                            //其他转化成GB
    sizeStr = (size / (1024 * 1024 * 1024)).toFixed(2) + " GB"
  }
  return sizeStr;
}

export const getFormatDuration = (seconds?: number) => {
  if (!seconds) return '-';
  const minute = Math.floor(seconds / 60);
  const second = seconds % 60;
  return `${minute}分${second}秒`;
};
